export default "__VITE_ASSET__BwPziDSc__"